import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { PageHeader } from "@/components/site/PageHeader";
import { CTASection } from "@/components/site/CTASection";
import { IMAGES } from "@/data/content";
import { api } from "@/lib/api";

const ASPECT = {
  lg: "aspect-[4/5]",
  md: "aspect-[3/4]",
  sm: "aspect-square",
  wide: "aspect-[4/3]",
};

export default function Gallery() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/gallery")
      .then((r) => {
        if (r.data.length) setItems(r.data);
      })
      .catch(() => {});
  }, []);

  return (
    <div data-testid="gallery-page">
      <PageHeader
        eyebrow="Gallery"
        title="Where Craft Meets Flight"
        subtitle="Products, the Jodhpur workshop, NCC training camps, and defence demonstrations — a look inside fifty-two years of making things that fly."
        image={IMAGES.hero}
      />

      <section className="bg-aero-deep">
        <div className="mx-auto max-w-[1400px] px-5 py-20 sm:px-8 sm:py-28">
          <div className="columns-1 gap-4 sm:columns-2 lg:columns-3 [&>*]:mb-4">
            {items.map((item, i) => (
              <motion.figure
                key={i}
                data-testid={`gallery-item-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className="group relative block break-inside-avoid overflow-hidden rounded-xl border border-steel/20"
              >
                <img
                  src={item.src}
                  alt={item.caption}
                  className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${ASPECT[item.span]}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-aero-deep/85 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <figcaption className="absolute bottom-0 left-0 right-0 translate-y-3 p-5 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                  <span className="font-heading text-sm font-semibold text-ink">
                    {item.caption}
                  </span>
                </figcaption>
                <span className="absolute right-4 top-4 rounded-full border border-saffron/40 bg-aero-deep/60 px-3 py-1 font-heading text-[10px] uppercase tracking-[0.18em] text-saffron backdrop-blur">
                  Est. 1974
                </span>
              </motion.figure>
            ))}
          </div>
        </div>
      </section>

      <CTASection
        title="Want to see more?"
        subtitle="Visit our Jodhpur facility, or reach out for a detailed product catalogue and demonstration footage."
      />
    </div>
  );
}
